import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { InfogeoModel } from './models/infogeo.model';
import { SsoService } from '../sso/sso.service';
import { lastValueFrom, map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MapsService {
  private urlApi = this.ssoService.getTicket().UrlApi;

  constructor(private http: HttpClient, private ssoService: SsoService) { }

  async getCoordinatesByDirection(
    numero: string,
    calle: string,
    municipio: string,
    provincia: string,
    comunidadAutonoma: string,
    codigoPostal: string,
    poblacion: string
  ): Promise<any> {
    let response = null;

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    }

    let direction: any = new Object();
    direction.Street = calle;
    //direction.PostalCode = codigoPostal;
    direction.District = poblacion;
    direction.Locality = municipio;
    direction.AdministrativeArea2 = provincia;
    direction.AdministrativeArea1 = comunidadAutonoma;
    direction.StreetNumber = numero;

    try {
      response = await this.http.post<any>(
        this.urlApi + '/api/maps?mapType='+(this.ssoService.getTicket().Empresa.CartoId+1),
        JSON.stringify(direction),
        httpOptions
      ).toPromise();
    }catch(e){
      response = null;
    }

    return response;
  }
}
